import React from "react";
import moment from "moment";
import { Table, Typography } from "antd";
import { useIntl } from "react-intl";
import { getLocalPhoneNumber } from "../../../components/util/helpers";

const { Title, Text } = Typography;

const WorkPlan = (props) => {
  const { recurrentEvents, print } = props;
  const intl = useIntl();
  let tableData = [];
  let durations = {};

  const sortedEvents =
    recurrentEvents &&
    recurrentEvents.length > 0 &&
    [...recurrentEvents].sort(
      (a, b) =>
        a.weekday - b.weekday || a.start_time_minutes - b.start_time_minutes
    );

  const names =
    recurrentEvents &&
    recurrentEvents.length > 0 &&
    recurrentEvents.map((i) => {
      const phone = i.employee.contact_info.mobile_number
        ? ` (${getLocalPhoneNumber(i.employee.contact_info.mobile_number)})`
        : i.employee.contact_info.phone_number
        ? ` (${getLocalPhoneNumber(i.employee.contact_info.phone_number)})`
        : "";
      return `${i.employee.first_name} ${i.employee.surename}${phone}`;
    });

  const unique =
    names && names.length > 0
      ? names
          .map((item) => item)
          .filter((value, index, self) => self.indexOf(value) === index)
      : [];

  if (sortedEvents) {
    sortedEvents.forEach((item, i) => {
      const startDate = moment()
        .startOf("day")
        .set("minute", item.start_time_minutes);
      const end = moment()
        .startOf("day")
        .set("minute", item.duration_minutes + item.start_time_minutes);
      const timeframe = startDate.format("HH:mm") + "-" + end.format("HH:mm");
      if (!tableData[0]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[0][item.weekday]) {
        tableData[0][item.weekday] = timeframe;
      } else if (!tableData[1]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[1][item.weekday]) {
        tableData[1][item.weekday] = timeframe;
      }
      durations[item.weekday] = durations[item.weekday]
        ? durations[item.weekday] + item.duration_minutes / 60
        : item.duration_minutes / 60;
      durations["total"] = durations["total"]
        ? durations["total"] + item.duration_minutes / 60
        : item.duration_minutes / 60;
    });
  }
  let roundDurations = {};
  Object.keys(durations).map(
    (key) => (roundDurations[key] = Math.round(durations[key] * 100) / 100)
  );
  tableData.push(roundDurations);

  const columns = [
    {
      title: moment.weekdays()[0],
      dataIndex: "0",
      key: "0",
    },
    {
      title: moment.weekdays()[1],
      dataIndex: "1",
      key: "1",
    },
    {
      title: moment.weekdays()[2],
      dataIndex: "2",
      key: "2",
    },
    {
      title: moment.weekdays()[3],
      dataIndex: "3",
      key: "3",
    },
    {
      title: moment.weekdays()[4],
      dataIndex: "4",
      key: "4",
    },
    {
      title: moment.weekdays()[5],
      dataIndex: "5",
      key: "5",
    },
    {
      title: moment.weekdays()[6],
      dataIndex: "6",
      key: "6",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.total",
      }),
      dataIndex: "total",
      key: "7",
    },
  ];
  return (
    <div
      className="borderedSection"
      style={{
        width: "100%",
        padding: "0 10px",
        border: "1px dashed",
        paddingBottom: "5px",
      }}
    >
      <Title level={4}>
        {intl.formatMessage({
          id: "app.house_visits.table.work_plan",
        })}
      </Title>
      <Text>{unique.join(", ")}</Text>
      <div>
        {print ? (
          <div className="vertical_spacer" />
        ) : (
          <div className="vertical_spacer high" />
        )}

        <Table
          bordered
          columns={columns}
          dataSource={tableData.map((i, index) => ({ ...i, key: index }))}
          pagination={false}
          size="small"
          rowKey={(record) => record.key}
        />
      </div>
    </div>
  );
};

export default WorkPlan;
